import React from 'react';
import { Field } from 'redux-form';
import _ from 'lodash';

import { SearchSelectBox } from 'jbc-front/components/SearchForm';
import { arrowRenderer } from 'jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import { Download } from 'jbc-front/components/icons';

import {
  NOTIFICATION_OF_BASE_AMOUNT_REVISION_FILTER_TYPES,
  NOTIFICATION_OF_BASE_AMOUNT_REVISION_SORT_TYPES
} from 'src/constants/Options';
import { EMPLOYEE_PAY_LIST } from 'src/constants/EndpointUrls';
import MainSearchSelectBox from 'src/components/MainSearchSelectBox';
import LoadingView from 'src/components/LoadingView';
import { ErrorsSection } from 'src/components';
import GeneralBtn from 'src/buttons/GeneralBtn';
import styles from './Header.scss';
import ConfirmRevisionModal from '../containers/Modal/ConfirmRevisionModalContainer';
import PdfModalBaseContainer from '../containers/PdfModalBaseContainer';
import CsvModalContainer from '../containers/Modal/CsvModalContainer';

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPdfPreview: false,
      isConfirmModalOpen: false,
      isCsvModalOpen: false
    };
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.openCsvModal = this.openCsvModal.bind(this);
    this.closeCsvModal = this.closeCsvModal.bind(this);
  }

  componentDidMount() {
    const { fetchNotificationOfBaseAmountMonthOptions } = this.props;
    fetchNotificationOfBaseAmountMonthOptions();
  }

  shouldComponentUpdate(nextProps) {
    // 年度を変更した際にデータ取得前に一瞬headerがレンダリングされるのを防止している
    // 本来loadingの画像を出すなどで対応すべきなので余裕があれば修正する
    return this.props.yearMonth === nextProps.yearMonth;
  }

  openConfirmModal() {
    if (this.state.isConfirmModalOpen) return;
    this.setState({ ...this.state, isConfirmModalOpen: true });
  }

  closeConfirmModal() {
    if (!this.state.isConfirmModalOpen) return;
    this.setState({ ...this.state, isConfirmModalOpen: false });
  }

  openCsvModal() {
    if (this.state.isCsvModalOpen) return;
    this.setState({ ...this.state, isCsvModalOpen: true });
  }

  closeCsvModal() {
    if (!this.state.isCsvModalOpen) return;
    this.setState({ ...this.state, isCsvModalOpen: false });
  }

  showPreview = () => {
    this.setState({ isPdfPreview: true });
  };

  hidePreview = () => {
    this.setState({ isPdfPreview: false });
  };

  NoContent = () => (
    <div className={styles.noContent}>
      <div className={styles.noContentText}>
        <p className={styles.noContentTextPrimary}>表示できる算定基礎届がありません。 </p>
        <p className={styles.noContentTextPrimary}>連続した4ヶ月分の給与を確定させると表示されます。</p>
        <p className={styles.noContentTextSecondary}>
          ※算定基礎届に関する詳細は
          <a
            className="u-txt-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://jobcan-payroll.zendesk.com/hc/ja/articles/360002145953-%E9%9A%8F%E6%99%82%E6%94%B9%E5%AE%9A%E3%82%92%E8%A1%8C%E3%81%86-%E6%9C%88%E9%A1%8D%E5%A4%89%E6%9B%B4%E5%B1%8A%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6-"
          >
            ヘルプページ
          </a>
          をご覧ください
        </p>
      </div>
      <div className={styles.noContentButton}>
        <GeneralBtn as="a" text="給与一覧へ" href={EMPLOYEE_PAY_LIST} />
      </div>
    </div>
  );

  sortRenderValue = option => <div>表示順：{option.label}</div>;
  filterRenderValue = option => <div>絞り込み：{option.label}</div>;

  render() {
    const {
      revisionYear,
      yearMonth,
      extras,
      hasInvalidMonthsErrors,
      revisionErrors,
      isOptionsLoading,
      filterAlertTargets,
      unconfirmedAlertCount
    } = this.props;
    const isNoData = _.isEmpty(revisionYear);

    const isAllConfirmedAlert =
      _.isUndefined(unconfirmedAlertCount) || (!_.isUndefined(unconfirmedAlertCount) && unconfirmedAlertCount === 0);

    return (
      <LoadingView isLoading={isOptionsLoading}>
        <div className="l-wrap-xl">
          {isNoData && <this.NoContent />}
          {!isNoData && (
            <React.Fragment>
              <div className={styles.select}>
                <Field
                  name="yearMonth"
                  component={MainSearchSelectBox}
                  options={revisionYear}
                  arrowRenderer={arrowRenderer}
                  width={248}
                />
              </div>
              {!hasInvalidMonthsErrors && (
                <div>
                  <ErrorsSection errors={revisionErrors} />
                  {!isAllConfirmedAlert && (
                    <div className={styles.alertBox}>
                      <p>{`正確に判定できない対象者が${unconfirmedAlertCount}名います`}</p>
                      <Button primary onClick={filterAlertTargets}>
                        対象者を表示
                      </Button>
                    </div>
                  )}
                  <div className={styles.column}>
                    <div>
                      <ul className="m-list-notes">
                        <li>※9月分以降の標準報酬月額が変更され、10月支給分からの給与に適用されます</li>
                      </ul>
                      <div className={styles.target}>
                        対象者：<span>{extras.targetCount}名</span>
                      </div>
                    </div>
                    <Button primary onClick={this.openConfirmModal} disabled={isAllConfirmedAlert ? '' : 'disabled'}>
                      標準報酬月額改定
                    </Button>
                  </div>
                  <div className={styles.action}>
                    <div className={styles.actionSelectBoxes}>
                      <div className={styles.actionSelectBoxesChild}>
                        <Field
                          name="sortType"
                          component={SearchSelectBox}
                          valueRenderer={this.sortRenderValue}
                          options={NOTIFICATION_OF_BASE_AMOUNT_REVISION_SORT_TYPES}
                        />
                      </div>
                      <div className={styles.actionSelectBoxesChild}>
                        <Field
                          name="filterType"
                          component={SearchSelectBox}
                          options={NOTIFICATION_OF_BASE_AMOUNT_REVISION_FILTER_TYPES}
                          valueRenderer={this.filterRenderValue}
                          classNames={styles.actionSelectBoxesChild}
                        />
                      </div>
                    </div>
                    <div className={styles.actionMediaCreateBoxes}>
                      <PdfModalBaseContainer revisionYear={yearMonth} isAllConfirmedAlert={isAllConfirmedAlert} />
                      <Button
                        primary
                        icon={<Download />}
                        onClick={this.openCsvModal}
                        disabled={isAllConfirmedAlert ? '' : 'disabled'}
                      >
                        CSVダウンロード
                      </Button>
                    </div>
                  </div>

                  {this.state.isConfirmModalOpen && (
                    <ConfirmRevisionModal
                      isOpen={this.state.isConfirmModalOpen}
                      hideModal={this.closeConfirmModal}
                      yearMonth={yearMonth}
                    />
                  )}
                  {this.state.isCsvModalOpen && (
                    <CsvModalContainer
                      isOpen={this.state.isCsvModalOpen}
                      hideModal={this.closeCsvModal}
                      yearMonth={yearMonth}
                    />
                  )}
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </LoadingView>
    );
  }
}
